import { StoreState } from 'types';

const getAssistantResponse = (state: StoreState) => state.assistant.response;
const getAssistantThreadId = (state: StoreState) => state.assistant.threadId;
const getAssistantStatus = (state: StoreState) => state.assistant.status;

export { getAssistantResponse, getAssistantThreadId, getAssistantStatus };
